import React, { useEffect, useRef } from "react"
import { makeStyles, withStyles } from "@material-ui/core"
import Tabs from "@material-ui/core/Tabs"
import AppBar from "@material-ui/core/AppBar"

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    minHeight: "100vh",
  },
  appBar: {
    backgroundColor: theme.palette.primary.lightest,
    color: theme.palette.primary.main,
    boxShadow: "none",
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    marginLeft: -40, // compensate for tabIndicator arrows
    marginRight: -40, // compensate for tabIndicator arrows
    marginBottom: props => props.marginBottom ?? theme.spacing(2),
    width: "calc(100% + 80px)", // full width plus the fill 40px on each side for tabIndicators
    height: "2.75rem",
    lineHeight: 1.4,
  },
  tabIndicator: {
    backgroundColor: theme.palette.primary.main,
    height: props => props.tabIndicatorHeight,
  },
  tabResult: {
    padding: 0,
  },
  tabItem: {
    fontSize: "1.1rem",
  },
}))

const StyledTabs = withStyles({
  root: {
    minHeight: "2.75rem",
  },
  scrollButtons: {
    display: "flex",
    padding: 4,
    justifyContent: "flex-start", // the navigation arrow on the right hand side
    "&:first-child": {
      // the one on the left
      justifyContent: "flex-end",
    },
  },
})(Tabs)

export default function TabWrapper(props) {
  const {
    children,
    selectedCriterion,
    handleChange,
    tabIndicatorHeight,
    marginBottom,
  } = props
  const classes = useStyles({tabIndicatorHeight, marginBottom})
  return (
    <AppBar position="sticky" className={classes.appBar}>
      <StyledTabs
        variant="scrollable"
        scrollButtons="on"
        TabIndicatorProps={{ className: classes.tabIndicator }}
        value={selectedCriterion}
        onChange={handleChange}
      >
        {children}
      </StyledTabs>
    </AppBar>
  )
}
